import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=460289c1&scoped=true"
import script from "./Register.vue?vue&type=script&lang=ts"
export * from "./Register.vue?vue&type=script&lang=ts"
import style0 from "./Register.vue?vue&type=style&index=0&id=460289c1&prod&lang=scss"
import style1 from "./Register.vue?vue&type=style&index=1&id=460289c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460289c1",
  null
  
)

export default component.exports